// SEE: https://developer.mozilla.org/en-US/docs/Web/API/SubtleCrypto/digest
import ENV from 'config/env.conf';
import fromAnyToString from 'utils/converters/fromAnyToString';
import fromArrayBufferToHexString from 'utils/converters/fromArrayBufferToHexString.util';
import fromStringToBytes from 'utils/converters/fromStringToBytes.util';
import { isEnvTest } from 'utils/env/determine.util';
import nullBind from 'utils/functions/nullBind.util';
import logger from 'utils/logger.util';

const L = logger('withCachedPromise');

const digest = async (algorithm, args) => fromArrayBufferToHexString(await crypto.subtle.digest(algorithm, fromStringToBytes(JSON.stringify(args))));

const KEY_MAKER_MAP = Object.freeze({
  json: (args) => JSON.stringify(args),
  compact1: nullBind(digest, 'SHA-1'),
  compact256: nullBind(digest, 'SHA-256'),
});

const IS_DIGEST_SAFE = (() => {
  // NOTE: in some old iOS Safari browsers, during development, the crypto.subtle.digest throws an error
  try {
    // noinspection JSIgnoredPromiseFromCall
    L.unignore('crypto.subtle.digest:', crypto.subtle.digest('SHA-1', new ArrayBuffer(8)));
    return true;
  } catch (e) {
    return false;
  }
})();

// old jsdom and node don't support the crypto available in browsers, so test with json
const DEFAULT = !IS_DIGEST_SAFE || isEnvTest() ? 'json' : fromAnyToString(ENV.REACT_APP_KEY_MAKER) || 'compact1';

const determineKeyMaker = () => KEY_MAKER_MAP[DEFAULT];

export default determineKeyMaker;
